import { render, staticRenderFns } from "./QuestionModal.vue?vue&type=template&id=4141d265&scoped=true"
import script from "./QuestionModal.vue?vue&type=script&lang=js"
export * from "./QuestionModal.vue?vue&type=script&lang=js"
import style0 from "./QuestionModal.vue?vue&type=style&index=0&id=4141d265&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4141d265",
  null
  
)

export default component.exports